export enum AttributeType {
  NUMBER = 'NUMBER',
  PRICE = 'PRICE',
  DATE = 'DATE',
  TEXT_ONE_LINE = 'TEXT_ONE_LINE',
  TEXT_MULTI_LINE = 'TEXT_MULTI_LINE',
  FILE = 'FILE',
}
